import { gql } from '@apollo/client';

export const CREATE_CALPUFF_CONFIGURATION = gql`
    mutation createCalpuffConfiguration($input: CreateCalpuffConfigurationInput!) {
        facility {
            modelConfigurations {
                calpuffConfigurations {
                    createCalpuffConfiguration(input: $input) {
                        id
                    }
                }
            }
        }
    }
`;
